import React, { useEffect, useState } from 'react';
import { Modal } from '@storaensods/se-design-system';
import icons from './../../icons.svg';
import { mapItemCountsByBarcode } from '../../utils/helpers';

const RefillPlanDataView = ({
  replenishPlan,
  replenishRule,
  cabinetItems,
  currentItemsLoading,
  fetchCabinetItems,
  deviceCode,
  t,
}) => {
  const [refillNoteOpen, setRefillNoteOpen] = useState('');
  const [itemCounts, setItemCounts] = useState({});
  const itemsLoadingClass = currentItemsLoading ? 'loading' : '';

  useEffect(() => {
    fetchCabinetItems(deviceCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setItemCounts(mapItemCountsByBarcode(cabinetItems));
  }, [cabinetItems]);

  const getTargetInvAmount = productBarcode => {
    if (!replenishRule.error && replenishRule.rule) {
      const product = replenishRule.rule.find(
        rule =>
          _13digitBarcode(rule.barcodeType, rule.barcode) === productBarcode
      );
      return product?.targetInvAmount;
    } else {
      return null;
    }
  };

  const _13digitBarcode = (barcodeType, barcode) => {
    if (barcode.length === 13) return barcode;
    switch (barcodeType) {
      case 'EAN-13':
        return barcode;
      case 'EAN-8':
        return '00000' + barcode;
      case 'UPC-A':
        return '0' + barcode;
      default:
        return barcode;
    }
  };

  const openRefillNoteModal = () => {
    return (
      <Modal
        active={true}
        onClose={() => setRefillNoteOpen('')}
        hasCloseButton={false}
        fullScreen
      >
        <div className="replenish-plan__refillnote-modal">
          <p className="replenish-plan__refillnote-title">
            {t('common:refillNote')}{' '}
          </p>
          <div className="replenish-plan__refillnote-text">
            {refillNoteOpen}
          </div>
          <div
            className="replenish-plan__refillnote-footer"
            onClick={() => setRefillNoteOpen('')}
          >
            <svg>
              <use xlinkHref={`${icons}#icon-close-outline`}></use>
            </svg>
            <span>{t('common:close')}</span>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <div className="replenish-plan__container">
      {refillNoteOpen && openRefillNoteModal()}
      <label className="replenish-plan__label">
        {' '}
        {t('common:plan_help_text')}
      </label>
      <div className="replenish-plan__table-container">
        <div
          id="replenish-plan__table-header"
          className="replenish-plan__table-container-header"
        >
          <div className="replenish-plan__table-container-header-title">
            {t('common:products')}
          </div>
          <div>
            <span
              className={`replenish-plan__table-container-header-cabinet-refresh ${itemsLoadingClass}`}
              onClick={() =>
                !currentItemsLoading && fetchCabinetItems(deviceCode)
              }
            >
              <svg className={itemsLoadingClass}>
                <use xlinkHref={`${icons}#icon-refresh`}></use>
              </svg>
              <span>{t('common:inventory')}</span>
            </span>
            <div className="replenish-plan__table-container-header-target">
              {t('common:target')}
            </div>
          </div>
        </div>
        <div id="replenish-plan__table-header-space-placeholder"></div>
        <div>
          {replenishPlan.plan &&
            replenishPlan.plan
              .filter(sku => sku.amountToRefill !== 0)
              .map((sku, i) => (
                <div className="replenish-plan__inventory" key={i}>
                  <div className="replenish-plan__product">
                    <div className="replenish-plan__inventory-image-container">
                      {sku.imageUrl ? (
                        <img
                          src={sku.imageUrl}
                          className="replenish-plan__inventory-image"
                          alt="product"
                        />
                      ) : !sku.imageUrl ? (
                        <svg className="replenish-plan__inventory-image-no-image">
                          <use xlinkHref={`${icons}#icon-cube`}></use>
                        </svg>
                      ) : (
                        <svg className="replenish-plan__inventory-image replenish-plan__inventory-image-unknown">
                          <use xlinkHref={`${icons}#icon-help`}></use>
                        </svg>
                      )}
                    </div>
                    <div className="replenish-plan__inventory-name-container">
                      <span className="replenish-plan__inventory-name-container-name">
                        {sku.name}
                      </span>
                      <div className="replenish-plan__inventory-name-container-chips">
                        {sku.amountToRefill > 0 ? (
                          <span className="replenish-plan__inventory-name-container-chips-add">
                            {`${t('common:add')}: ${sku.amountToRefill}`}
                          </span>
                        ) : null}
                        {sku.amountToRefill < 0 ? (
                          <span className="replenish-plan__inventory-name-container-chips-remove">
                            {`${t('common:remove')}: ${Math.abs(
                              sku.amountToRefill
                            )}`}
                          </span>
                        ) : null}
                        <span className="replenish-plan__inventory-name-container-chips-cabinet">
                          {`${t('common:inventory')}: ${
                            currentItemsLoading
                              ? '-'
                              : itemCounts[sku.barcode] || '0'
                          }`}
                        </span>
                      </div>
                    </div>
                    <div className="replenish-plan__inventory-target-container">
                      <div className="replenish-plan__inventory-target-container-target">
                        {getTargetInvAmount(sku.barcode)}
                      </div>
                    </div>
                  </div>
                  {sku.refillNote && (
                    <div
                      className="replenish-plan__refillnote"
                      onClick={() => setRefillNoteOpen(sku.refillNote)}
                    >
                      <svg>
                        <use xlinkHref={`${icons}#icon-clipboard-edit`}></use>
                      </svg>
                      <span>{t('common:refillNote')}</span>
                    </div>
                  )}
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default RefillPlanDataView;
